const routes = {
  HOME: '/',
  LOGIN: '/login',
  REGISTRATION: '/registration',
  FORGOT_PASSWORD: '/forgot_password',
  FORGOT_RESET: '/reset_password',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  ROLES: '/user-management/roles',
  ROLE_DETAILS: '/user-management/roles/:id',
  USERS: '/user-management/users',
  USER_DETAILS: '/user-management/users/:id',
  USER_LOGS: '/user-logs/',
  SUPPLIER_API_LOGS: '/supplier-api-logs/',
  SUPPLIER_SETTINGS: '/supplier-settings/',
  SERVICE_TOKENS: '/user-management/service-tokens/',
  CO_ORDERED_PARTS: '/coilovers/ordered-parts/',
  CO_WAREHOUSE: '/coilovers/warehouse/',
  CO_ORDERS: '/coilovers/orders/',
  ACCEPTANCE: '/coilovers/acceptance/',
  ARTICLES: '/articles',
  ARTICLES_EDIT: '/articles/edit',
  ARTICLES_NEW: '/articles/new',
  COMPATIBILITY: '/compatibility',
  PRINTER: '/printer',
  EBAY_TASKS: '/ebay/tasks',
  JOBS_IN_PROGRESS: '/jobs/in-progress',
  JOBS_FAILED: '/jobs/failed',
  JOBS_FAILED_IMPORT_ROWS: '/jobs/failed-import-rows',
};

export default routes;
